import { useCallback, useEffect, useState } from "react";

import "./App.css";
import Toolbar from "./components/Toolbar";
import TradingViewChart from "./components/TradingViewChart";
import { readWorkspace, writeWorkspace } from "./lib/workspace";

function App() {
  // The URL owns chart state, so a shared link restores the exact view.
  const [workspace, setWorkspace] = useState(readWorkspace);

  useEffect(() => {
    writeWorkspace(workspace);
  }, [workspace]);

  const update = useCallback(
    (patch) => setWorkspace((prev) => ({ ...prev, ...patch })),
    [],
  );

  /** Loads a symbol into the chart. */
  const loadSymbol = useCallback(
    (symbol) =>
      setWorkspace((prev) => {
        const symbols = [...prev.symbols];
        symbols[0] = symbol;
        return { ...prev, symbols };
      }),
    [],
  );

  return (
    <div className={`app app--${workspace.theme}`}>
      <Toolbar
        interval={workspace.interval}
        theme={workspace.theme}
        onSymbol={loadSymbol}
        onInterval={(interval) => update({ interval })}
        onTheme={(theme) => update({ theme })}
      />

      <main className="workspace">
        <section className="grid grid--1">
          <TradingViewChart
            symbol={workspace.symbols[0]}
            interval={workspace.interval}
            theme={workspace.theme}
          />
        </section>
      </main>
    </div>
  );
}

export default App;
